// Adds hover-intent opening to Dawn's header-menu (mega menu) on devices with a
// real mouse. Touch and keyboard users keep Dawn's native click/Enter/focus
// behavior (see details-disclosure.js) untouched — this only layers hover on top.
(function () {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  document.querySelectorAll('.header__inline-menu header-menu').forEach(function (menu) {
    var details = menu.querySelector('details');
    if (!details) return;
    var summary = details.querySelector('summary');
    var closeTimer;

    function open() {
      clearTimeout(closeTimer);
      if (details.hasAttribute('open')) return;
      details.setAttribute('open', '');
      if (summary) summary.setAttribute('aria-expanded', 'true');
      details.dispatchEvent(new Event('toggle'));
    }

    function scheduleClose() {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        details.removeAttribute('open');
        if (summary) summary.setAttribute('aria-expanded', 'false');
        details.dispatchEvent(new Event('toggle'));
      }, 150);
    }

    menu.addEventListener('mouseenter', open);
    menu.addEventListener('mouseleave', scheduleClose);
  });
})();
